import { ReportFeatures } from '@hcs/types';

export const APPRAISAL_COMP_DATA_SOURCES_FEATURES = [
  ReportFeatures.AppraisalComps,
];
